import React from 'react'
import { CampaignCard } from '../campaign_card'
import { CardListProps } from './types'
const CardList = ({ edges, loading }: CardListProps) => {
  if (loading || !edges) {
    return (
      <>
        {Array(4)
          .fill(1)
          .map((_, i) => (
            <CampaignCard.Dummy key={i} />
          ))}
      </>
    )
  }

  return (
    <>
      {edges.map(({ node }, i) => (
        <CampaignCard campaign={node} key={i} />
      ))}
    </>
  )
}

export default CardList
